module.exports = __webpack_public_path__ + "static/img/imagine_english.533525d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/homePage/index/PCImage/imagine_english.png
// module id = lgVr
// module chunks = 1